// extracted by mini-css-extract-plugin
export default {"root":"EditKit_root__0Vluk","placeHolderShimmer":"EditKit_placeHolderShimmer__G-tns"};